import { BALANCE_SLIDE_STEP } from '../../data-types/enums';
import { CardType, DEPOSIT_CONFIRMATION_TYPE } from '../../data-types/wallet/walletEnums';
import {
  DepositInfoNotification,
  DepositTrackingInfo,
  MobilePaymentInitDialog,
  UserBonusWallet,
  UserPaymentMethodsData,
} from '../../data-types/wallet/walletInterfaces';
import { store } from '../store';
import {
  SET_ACKNOWLEDGE_DEPOSIT_OPEN,
  SET_DEPOSIT_AMOUNT,
  SET_DEPOSIT_CARD_TYPE,
  SET_DEPOSIT_CONFIRMATION_TYPE,
  SET_DEPOSIT_NOTIFICATION_CONTENT,
  SET_DEPOSIT_TRACKING_INFO,
  SET_MOBILE_PAYMENT_INIT_DIALOG,
  SET_USER_BALANCE,
  SET_USER_BONUS_WALLET,
  SET_USER_PAYMENT_METHODS_DATA,
  SET_USER_PAYMENT_METHODS_DATA_LOADING,
  SET_USER_TOTAL_BALANCE,
  SET_WALLET_BALANCE_TYPE_DISPLAY,
} from '../types/walletTypes';

export const setUserBalance = (balance: number) => {
  store.dispatch({
    type: SET_USER_BALANCE,
    meta: balance,
  });
};

export const setDepositConfirmationType = (meta: DEPOSIT_CONFIRMATION_TYPE) => {
  store.dispatch({
    meta,
    type: SET_DEPOSIT_CONFIRMATION_TYPE,
  });
};

export const setDepositAmount = (meta: number) => {
  store.dispatch({
    meta,
    type: SET_DEPOSIT_AMOUNT,
  });
};

export const setDepositCardType = (meta: CardType) => {
  store.dispatch({
    meta,
    type: SET_DEPOSIT_CARD_TYPE,
  });
};

export const setDepositNotificationContent = (meta: DepositInfoNotification) => {
  store.dispatch({
    meta,
    type: SET_DEPOSIT_NOTIFICATION_CONTENT,
  });
};

export const setDepositTrackingInfo = (meta: DepositTrackingInfo) => {
  store.dispatch({
    meta,
    type: SET_DEPOSIT_TRACKING_INFO,
  });
};

export const setMobilePaymentInitDialog = (meta: MobilePaymentInitDialog) => {
  store.dispatch({
    meta,
    type: SET_MOBILE_PAYMENT_INIT_DIALOG,
  });
};

export const setUserPaymentMethodsData = (meta: UserPaymentMethodsData) => {
  store.dispatch({
    meta,
    type: SET_USER_PAYMENT_METHODS_DATA,
  });
};

export const setUserPaymentMethodsLoadingFlag = (meta: boolean) => {
  store.dispatch({
    meta,
    type: SET_USER_PAYMENT_METHODS_DATA_LOADING,
  });
};

export const setAcknowledgeDepositOpen = (meta: boolean) => {
  store.dispatch({
    meta,
    type: SET_ACKNOWLEDGE_DEPOSIT_OPEN,
  });
};

export const setUserTotalBalance = (totalBalance: number) => {
  store.dispatch({
    type: SET_USER_TOTAL_BALANCE,
    meta: totalBalance,
  });
};

export const setUserBonusWallet = (bonusWallet: UserBonusWallet | undefined) => {
  store.dispatch({
    type: SET_USER_BONUS_WALLET,
    meta: bonusWallet,
  });
};

export const setWalletBalanceTypeDisplay = (meta: BALANCE_SLIDE_STEP) => {
  store.dispatch({
    meta,
    type: SET_WALLET_BALANCE_TYPE_DISPLAY,
  });
};
